export default __webpack_public_path__ + "static/media/aeps-balance.40611485.svg";